import React, {
  useEffect,
  useState,
} from 'react';
import {
  downloadFile,
} from 'pages/Dashboard/utils/helper';
import ToolTip from 'core/components/Tooltip';
import IconButton from '@mui/material/IconButton';
import Spinner from 'pages/Dashboard/components/Spinner';
import uniqueId from 'lodash/uniqueId';
import clsx from 'clsx';
import DownloadIcon from 'core/icons/download';
import capitalize from 'lodash/capitalize';
import {
  useDownloadFile,
} from 'pages/Dashboard/pages/Billing/hooks';
import {
  useMixpanelTrack,
} from 'core/hooks';
import isNil from 'lodash/isNil';

export const keysForFileDownload = Object.freeze([
  'isComplete',
  'isFileMissing',
  'fileMissingReason',
]);

type Props = {
  id: number;
  isComplete?: boolean;
  isFileMissing?: boolean | null;
  fileMissingReason?: string | null;
  type: string;
};

export default function FileDownloadButton({
  id,
  isComplete,
  isFileMissing,
  fileMissingReason,
  type,
}: Props) {
  const mixPanelTrack = useMixpanelTrack();
  const [downloadId, setDownloadId] = useState<string | null>(null);
  const {
    data: fileResult,
    isLoading,
  } = useDownloadFile(id ?? 0, downloadId, type);

  useEffect(() => {
    downloadFile(fileResult ?? {});
    if (!isNil(fileResult?.contents) && type === 'report') {
      mixPanelTrack(`download${capitalize(type)}`, { reportId: id });
    }
  }, [fileResult]);

  const tooltip = isFileMissing ? fileMissingReason : `Download ${type}`;
  const disabled = !isComplete || (isFileMissing ?? false);

  return (
    <ToolTip
      title={isComplete ? tooltip : `Please wait until ${type} ready`}
    >
      <span>
        <IconButton
          disabled={disabled}
          onClick={() => {
            setDownloadId(uniqueId(`download_${type}_`));
          }}
          className={clsx({
            '!cursor-not-allowed !pointer-events-auto': disabled,
          })}
        >
          {isLoading
            ? <Spinner size={16} />
            : (
              <DownloadIcon className={clsx('!w-4 !h-4 text-gray-700', {
                '!text-gray-300': disabled,
              })}
              />
            )}
        </IconButton>
      </span>
    </ToolTip>
  );
}
